module.exports = __webpack_public_path__ + "img/火箭军工程大学.223ee256.png";